import { Link } from "react-router-dom";
import { Sparkles, ArrowLeft } from "lucide-react";
import Footer from "../components/Footer";

export default function CookiePolicy() {
  return (
    <div className="min-h-screen bg-[#FAFAF8] flex flex-col">
      <header className="container-bsp h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-md bg-[#1A1F3D] flex items-center justify-center">
            <Sparkles className="w-4 h-4 text-[#D4A853]" />
          </div>
          <span className="font-display text-xl text-[#1A1F3D]">BrandSnapPro™</span>
        </Link>
        <Link to="/" className="text-sm text-[#52525b] inline-flex items-center gap-1.5 hover:text-[#1A1F3D]">
          <ArrowLeft className="w-4 h-4" /> Back to home
        </Link>
      </header>
      <main className="flex-1 container-bsp py-16 max-w-3xl">
        <span className="eyebrow">Legal</span>
        <h1 className="font-display text-4xl md:text-5xl text-[#1A1F3D] mt-3">Cookie Policy</h1>
        <p className="text-[#52525b] mt-2 text-sm">Last updated: {new Date().toLocaleDateString("en-GB", { dateStyle: "long" })}</p>
        <div className="mt-8 space-y-5 text-[#2D2D2D] leading-relaxed">
          <p>BrandSnapPro™ uses a small number of strictly essential cookies and similar browser storage to make the service work. We do not use advertising, profiling, or third-party tracking cookies.</p>

          <h2 className="font-display text-2xl text-[#1A1F3D] mt-8">What we use</h2>
          <ul className="list-disc pl-5 space-y-2">
            <li><span className="font-medium text-[#1A1F3D]">Authentication</span> — to keep you logged in between visits.</li>
            <li><span className="font-medium text-[#1A1F3D]">Stripe</span> — to securely process your one-time £79 payment. Stripe sets its own cookies on the checkout page; see <a className="gold-link" href="https://stripe.com/cookie-settings" target="_blank" rel="noopener noreferrer">stripe.com/cookie-settings</a>.</li>
            <li><span className="font-medium text-[#1A1F3D]">Cookie consent</span> — to remember that you've already seen our cookie banner so we don't show it on every visit.</li>
          </ul>

          <h2 className="font-display text-2xl text-[#1A1F3D] mt-8">What we don't use</h2>
          <p>No advertising cookies. No cross-site tracking. No profiling. We do not sell your data.</p>

          <h2 className="font-display text-2xl text-[#1A1F3D] mt-8">Managing cookies</h2>
          <p>You can clear cookies and browser storage at any time from your browser settings. Note that doing so will sign you out and you'll see the cookie banner again on your next visit.</p>

          <h2 className="font-display text-2xl text-[#1A1F3D] mt-8">Contact</h2>
          <p>Questions? Email <a className="gold-link" href="mailto:contact@aicompass.co.uk">contact@aicompass.co.uk</a>.</p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
